import { apiClient } from '../../utils';
import { handleError } from '../';

export const createSlider = async ({ siteId, title, status, tp }) => {
  try {
    const { result } = await apiClient.post('/merchant/slider/create', {
      data: {
        site: siteId,
        title,
        status: status || 0,
        ...(tp ? { type: tp } : {}),
      },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
